"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var utils_1 = require("./utils");
exports.SPEC_ENDPOINTS = {
    internalMonitoringEndpoint: 'https://monitoring-intake.com/abcde?foo=bar',
    logsEndpoint: 'https://logs-intake.com/abcde?foo=bar',
    rumEndpoint: 'https://rum-intake.com/abcde?foo=bar',
    traceEndpoint: 'https://trace-intake.com/abcde?foo=bar',
};
function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
exports.isSafari = isSafari;
function isFirefox() {
    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
}
exports.isFirefox = isFirefox;
function isIE() {
    return navigator.userAgent.indexOf('MSIE ') > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./);
}
exports.isIE = isIE;
function clearAllCookies() {
    document.cookie.split(';').forEach(function (c) {
        document.cookie = c.replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/;samesite=strict");
    });
}
exports.clearAllCookies = clearAllCookies;
function stubFetch() {
    var _this = this;
    var originalFetch = window.fetch;
    var allFetchCompleteCallback = utils_1.noop;
    var pendingRequests = 0;
    function onRequestEnd() {
        pendingRequests -= 1;
        if (pendingRequests === 0) {
            setTimeout(function () { return allFetchCompleteCallback(); });
        }
    }
    window.fetch = (function () {
        pendingRequests += 1;
        var resolve;
        var reject;
        var promise = new Promise(function (res, rej) {
            resolve = res;
            reject = rej;
        });
        promise.resolveWith = function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var resolved;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                resolved = resolve(tslib_1.__assign(tslib_1.__assign({}, response), { clone: function () {
                        var cloned = {
                            text: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                return tslib_1.__generator(this, function (_a) {
                                    if (response.responseTextError) {
                                        throw response.responseTextError;
                                    }
                                    return [2 /*return*/, response.responseText];
                                });
                            }); },
                        };
                        return cloned;
                    } }));
                onRequestEnd();
                return [2 /*return*/, resolved];
            });
        }); };
        promise.rejectWith = function (error) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var rejected;
            return tslib_1.__generator(this, function (_a) {
                rejected = reject(error);
                onRequestEnd();
                return [2 /*return*/, rejected];
            });
        }); };
        return promise;
    });
    return {
        whenAllComplete: function (callback) {
            allFetchCompleteCallback = callback;
        },
        reset: function () {
            window.fetch = originalFetch;
            allFetchCompleteCallback = utils_1.noop;
        },
    };
}
exports.stubFetch = stubFetch;
var PerformanceObserverStubBuilder = /** @class */ (function () {
    function PerformanceObserverStubBuilder() {
    }
    PerformanceObserverStubBuilder.prototype.getEntryTypes = function () {
        // tslint:disable-next-line: no-unsafe-any
        return this.instance.entryTypes;
    };
    PerformanceObserverStubBuilder.prototype.fakeEntry = function (entry, entryType) {
        var asEntryList = function () { return [entry]; };
        // tslint:disable-next-line: no-unsafe-any
        this.instance.callback({
            getEntries: asEntryList,
            getEntriesByName: asEntryList,
            getEntriesByType: function (type) {
                if (type === entryType) {
                    return asEntryList();
                }
                return [];
            },
        });
    };
    PerformanceObserverStubBuilder.prototype.getStub = function () {
        var _a;
        // tslint:disable-next-line:no-this-assignment
        var builder = this;
        return _a = /** @class */ (function () {
                function class_1(callback) {
                    this.callback = callback;
                    builder.instance = this;
                }
                class_1.prototype.observe = function (options) {
                    if (options) {
                        // tslint:disable-next-line: no-unsafe-any
                        builder.instance.entryTypes = options.entryTypes;
                    }
                };
                return class_1;
            }()),
            _a.supportedEntryTypes = ['navigation'],
            _a;
    };
    return PerformanceObserverStubBuilder;
}());
exports.PerformanceObserverStubBuilder = PerformanceObserverStubBuilder;
function withXhr(_a) {
    var setup = _a.setup, onComplete = _a.onComplete;
    var xhr = new XMLHttpRequest();
    xhr.addEventListener('loadend', function () {
        setTimeout(function () {
            onComplete(xhr);
        });
    });
    setup(xhr);
}
exports.withXhr = withXhr;
function setPageVisibility(visibility) {
    Object.defineProperty(document, 'visibilityState', {
        get: function () {
            return visibility;
        },
        configurable: true,
    });
}
exports.setPageVisibility = setPageVisibility;
function restorePageVisibility() {
    delete document.visibilityState;
}
exports.restorePageVisibility = restorePageVisibility;
//# sourceMappingURL=specHelper.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@datadog/browser-core/cjs/specHelper.js
// module id = 753
// module chunks = 0